let keys

const hostname = window && window.location && window.location.hostname;

if (hostname === 'mygravy.gravy.work' || hostname === 'access.gravy.work') {
  keys = {
    INTERCOM_KEY: 'g4ntafaw',
    SEGMENT_KEY: 'dPJEOmI3NNnh3xeeaYHL4JdnEwywnmBs'
  };
} else {
  keys = {
    INTERCOM_KEY: 'p68js76f',
    SEGMENT_KEY: 'LxHQErWR49rm99izQmcPEgznjFeTJvY'
  };
}

export const analyticsKeys = keys;



// WEBPACK FOOTER //
// ./src/constants/analytics.js